import { render, staticRenderFns } from "./index.vue?vue&type=template&id=688b6f81&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "688b6f81",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('688b6f81')) {
      api.createRecord('688b6f81', component.options)
    } else {
      api.reload('688b6f81', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=688b6f81&scoped=true&", function () {
      api.rerender('688b6f81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/key-attributes/modules/table-list/index.vue"
export default component.exports